<template>
    <div v-if="question.isShow" class="question-item">
        <div class="question-title"><i v-if="question.isMust">*</i>{{question.title}}</div>
        <div  v-if="question.note">说明：{{question.note}}</div>
        <img class="qs-img-preview" :src="question.pictureUrl" alt="">
        <div class="ql-editor" v-html="question.paragraphConfig.contentHtml"></div>
    </div>
</template>

<script>
  import '@/assets/style/editor/quill.core.css'

  export default {
    name: 'question-para',
    props: {
      question: { required: true },
    },
    data () {
      return {
        currentIndex: null,
        fileList: [],
        uploader: [],
        imageList: [],
        jumpPageNumber: null,
        show: false
      }
    },
    created (){
      this.getPicture()
    },
    watch: {
    },
    methods: {
      checkIsFill (){
        return true
      },
      saveAnswer (){
      },
      getPicture() {
        if(this.question.pictureUrl) {
          this.$store.dispatch('getPicture', {url:[this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import "questionCommon";
    .question-option {
        .option-title {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            span {
                font-size: 16px;
                margin-left: 10px;
            }
        }

        .option-other {

        }
    }
</style>